var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { class: { loadIconBox: !_vm.instant && !_vm.isReady } },
    [
      _c("canvas", {
        directives: [
          {
            name: "show",
            rawName: "v-show",
            value: _vm.instant || _vm.isReady,
            expression: "instant || isReady",
          },
        ],
        ref: _vm.useDownSampling ? "scaledCanvas" : "canvas",
        staticClass: "mainCanvas",
        attrs: { width: _vm.canvasWidth, height: _vm.canvasHeight },
      }),
      _vm._v(" "),
      _vm.useDownSampling
        ? _c("canvas", {
            directives: [
              {
                name: "show",
                rawName: "v-show",
                value: false,
                expression: "false",
              },
            ],
            ref: "canvas",
            attrs: { width: _vm.maxCanvasWidth, height: _vm.maxCanvasHeight },
          })
        : _vm._e(),
      _vm._v(" "),
      _vm.instant || _vm.isReady
        ? _c("DrawView", {
            attrs: {
              "address-model": _vm.addressModel,
              "bleed-margin": _vm.bleedMargin,
              color: _vm.inverseColor,
              "draw-mask": _vm.showMask,
              "draw-objects": _vm.objectModels,
              "draw-overlay": _vm.showOverlay,
              "draw-page": true,
              "mirror-overlay": _vm.flippedOverlay,
              "page-model": _vm.pageModel,
              scaling: _vm.useDownSampling ? _vm.maxScale : _vm.scaling,
              "show-loaders": _vm.showLoaders,
            },
          })
        : _vm._e(),
      _vm._v(" "),
      !_vm.instant && !_vm.isReady
        ? _c(
            "svg",
            { attrs: { viewBox: "0 0 32 32", width: "64", height: "64" } },
            [
              _c("circle", {
                staticClass: "loadIcon",
                attrs: { cx: "16", cy: "16", r: "14", fill: "none" },
              }),
            ]
          )
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }